module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"amount_of_all_orders":"Total value of Orders Placed","amount_of_paid_for_orders":"Total cash receipts","amount_of_unpaid_for_orders":"Total value of open orders","delivered":"Total value of Orders Delivered","confirmed":"Total value of Orders Confirmed","placed":"Total value of Orders Placed"}}')
  delete Component.options._Ctor
}
